import PropTypes from 'prop-types';

export const ContractPropType = PropTypes.shape({
    // TODO: vervollständigen
    id: PropTypes.number.isRequired,
});

export const ContractEditPropType = PropTypes.shape({
    // TODO: vervollständigen
});
